import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { ReactComponent as Headphones } from "../../iconColor/headphones.svg";
// import { ReactComponent as Grid } from "../../iconColor/grid-outline.svg";
import { ReactComponent as Cart } from "../../iconColor/cart.svg";
// import { ReactComponent as Cog } from "../../iconColor/cog.svg";
import { ReactComponent as Home } from "../../iconColor/home.svg";
import { ReactComponent as Receipt } from "../../iconColor/receipt.svg";
import { ReactComponent as User } from "../../iconColor/user.svg";
// import { ReactComponent as Messages } from "../../iconColor/messages.svg";
import { ReactComponent as Logout } from "../../iconColor/arrow-right-to-bracket-outline.svg";
import Swal from "sweetalert2";
import { useUserContext } from "../../context/UserContext";
import { useStoreContext } from "../../context/StoreContext";
import { useCreditorContext } from "../../context/CreditorContext";

const UserPanelSidebar = (enteredUser: any, setEnteredUser: any) => {
  const [activeMenu, setActiveMenu] = useState<any>(
    window.location.href.split("https://vam30.com/fa/")[1]
  );
  const navigate = useNavigate();

  const { setUserData } = useUserContext();
  const { setStoreData } = useStoreContext();
  const { setCreditor } = useCreditorContext();

  const old_access_token = localStorage.getItem("old_access_token");

  const logOut = () => {
    Swal.fire({
      title: "آیا مطمئن هستید که می خواهید از حساب خود خارج شوید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#477CD1",
      cancelButtonColor: "white",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",
        icon: "no-border",
        title: "title-padding",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (!old_access_token) {
          localStorage.clear();
          document.cookie.split(";").forEach((cookie) => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
          setUserData(null);
          setStoreData(null);
          setCreditor(null);
          setEnteredUser(null);

          Swal.fire({
            title: "از حساب کاربری خود خارج شدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          navigate("/");
        } else {
          old_access_token &&
            localStorage.setItem("access_token", old_access_token);

          localStorage.removeItem("old_access_token");
          navigate("/fa/admin-dashboard");
        }
      }
    });
  };

  const TopMenus = [
    {
      title: "خانه",
      src: "/fa/user-panel",
      icon: <Home />,
      disable: false,
    },
    {
      title: "پروفایل",
      src: "/fa/user-panel/profile",
      icon: <User />,
      disable: false,
    },
    {
      title: "سفارش‌ها",
      src: "/fa/user-panel/orders",
      icon: <Cart />,
      disable: false,
    },
    {
      title: "اقساط ",
      src: "/fa/user-panel/instalments",
      icon: <Receipt />,
      disable: false,
    },
    {
      title: "سی کلاب",
      src: "/user-panel/30club",
      icon: <img src="/icons/coin.png" alt="" />,
      disable: false,
    },
  ];

  const ButtomMenus = [
    // {
    //   title: "تنظیمات ",
    //   src: "/fa/user-panel/setting",
    //   gap: true,
    //   icon: <Cog />,
    //   disable: true,
    // },
    // {
    //   title: "پشتیبانی",
    //   src: "/fa/user-panel/support",
    //   icon: <Headphones />,
    //   disable: true,
    // },
    // {
    //   title: "گفت‌وگو",
    //   src: "/fa/dashboard/chats",
    //   icon: <Messages />,
    //   disable: true,
    // },
    {
      title: `${
        !localStorage.getItem("old_access_token")
          ? "خروج از حساب"
          : "بازگشت به پنل ادمین"
      }`,
      src: "/fa/dashboard/logout",
      icon: <Logout />,
      disable: true,
    },
  ];

  const handleMenuItemClick = (menu: any) => {
    console.log("menu in click ", menu);
    setActiveMenu(menu.src);
    if (!menu?.subMenus && !menu.disable) navigate(`/${menu.src}`);

    if (menu.title === "خروج از حساب" || menu.title === "بازگشت به پنل ادمین") {
      logOut();
    }
  };

  console.log("TopMenus", TopMenus);
  console.log("activeMenu", activeMenu);

  return (
    <div className="hidden  m-10 min-w-[274px] max-w-[2800px] transition-width lg:block sticky top-0 min-h-fit h-fit rounded-3xl ease-in-out duration-300 z-50 bg-white shadow-button_sm_hover">
      <ul className="p-8">
        <>
          {TopMenus.map((Menu, index) => (
            <div
              key={index}
              onClick={() => {
                localStorage.setItem("user_active_menu", Menu.src);
              }}
              className="hover:bg-primary-50 rounded-lg  hover:text-primary-600"
            >
              <a
                href={Menu.src}
                key={index}
                className={` ${
                  Menu?.disable ? "hover:bg-gray-200 text-gray-400" : ""
                } flex rounded-md pt-2 pb-2 pl-2 pr-2 mb-4 cursor-pointer items-center gap-2 ${
                  localStorage.getItem("user_active_menu") === Menu.src
                    ? "bg-primary-50 rounded-lg text-primary-600"
                    : "text-gray-800"
                }`}
                // onClick={() => {
                //   handleMenuItemClick(Menu);
                // }}
              >
                {React.cloneElement(Menu.icon, {
                  className:
                    localStorage.getItem("user_active_menu") === Menu.src
                      ? "bg-primary-50"
                      : "text-gray-800",
                })}
                <span className="flex-1">{Menu.title}</span>
              </a>
            </div>
          ))}
          {/* <div className="p-2"></div> */}
          <hr className="p-4 mx-4" />

          {ButtomMenus.map((Menu, index) => (
            <div key={index}>
              <li
                key={index}
                className={` ${
                  Menu?.disable ? " text-gray-400" : ""
                } flex mx-3 rounded-md p-2 mb-3  items-center gap-2 
                            ${
                              Menu.title === "خروج از حساب" ||
                              Menu.title === "بازگشت به پنل ادمین"
                                ? "hover:text-red-700 cursor-pointer text-red-700 bg-white hover:bg-gray-50"
                                : ""
                            }
                            bg-gray-100 rounded-lg text-gray-600`}
                onClick={() => {
                  if (
                    Menu.title === "خروج از حساب" ||
                    Menu.title === "بازگشت به پنل ادمین"
                  )
                    handleMenuItemClick(Menu);
                }}
              >
                <div>{Menu?.icon}</div>
                <span className="flex-1">{Menu.title}</span>
              </li>
            </div>
          ))}
        </>
      </ul>
    </div>
  );
};

export default UserPanelSidebar;
